import styled from "styled-components";

export const RightSection = styled.div`
  display: flex;
  flex: 1;
  margin-inline-end: 15px;
  min-width: 500px;
  flex-direction: column;
`;

export const LeftSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 380px;
  align-content: center;
  justify-content: center;
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 0;

  @media (max-width: 1200px) {
    width: 100%;
    margin-top: 15px;
  }
`;

export const BranchesMapContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  margin-bottom: 16px;

  .leaflet-container {
    z-index: 0;
  }
`;

export const CoinWithdrawHistoryContainer = styled.div`
  flex: 1;
  height: 16vh;
  min-height: 350px;
  min-width: 1vw;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  background: ${(theme) => theme.theme.bgColor3};
  border-radius: 16px;
`;

export const MapPlaceholder = styled.div<{ height?: number }>`
  flex: 1;
  display: flex;
  justify-content: space-between;
  background: ${(theme) => theme.theme.bgColor3};
  border-radius: 16px;
  min-height: ${(p) => p.height || 400}px;
`;

export const MapDescriptionContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  background: ${(theme) => theme.theme.bgColor1};
  min-height: 16px;
  padding: 8px;
  color: white;
`;
